import React from 'react';
import { IChannels, ICommonAttributes, ILibraries } from "../../../types";
import { SOURCE_URL } from '../../../../../config';

import styles from './ChannelDemandPanel.module.scss';
import ImageFallback from "../../../../../utils/ImageFallback";
import { useAppDispatch } from "../../../../../stores/hook";
import { setFilterPlansInfo, setHideOtherPacks, setisShowFitlerPopUp } from "../../GetStartedSlice";

interface IchannelDemandPanel {
  title: string;
  list: IChannels[] | ILibraries[];
  type: string;
}
const ChannelDemandPanel:React.FC<IchannelDemandPanel> = (props) => {
  const dispatch = useAppDispatch();

  const onListItemClick = (e: React.MouseEvent, item:ICommonAttributes) => {
    const url = item?.icon?.data?.attributes?.formats?.thumbnail?.url ? SOURCE_URL + item?.icon?.data?.attributes?.formats?.thumbnail?.url : item?.icon?.data?.attributes?.url ? SOURCE_URL + item?.icon?.data?.attributes?.url : '';
    dispatch(setHideOtherPacks(true));
    dispatch(setFilterPlansInfo({filterChannelOrLibId: item.number, filterChanenlOrLibImg: url, type:props.type}));
    dispatch(setisShowFitlerPopUp(false));
  }

  const renderPanelItem = () => {
    return Array.isArray(props.list) && props.list.map((listItem, index) => (
      <div
        className={styles["channel"]}
        key={listItem.attributes.number + index}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          onListItemClick(e, listItem.attributes)
        }}>
        <button className={styles["channel-logo"]}>
          <ImageFallback
            primarySrc={listItem?.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url ? SOURCE_URL + listItem?.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url : listItem?.attributes?.icon?.data?.attributes?.url ? SOURCE_URL + listItem?.attributes?.icon?.data?.attributes?.url : ''}
            alt="Channel logo"
          />
        </button>
      </div>
      ))
  }
  return (
    <div className={styles['channel-demand-panel']}>
      <h4 className={styles.title}>{props.title}</h4>
      <div className={styles['filter-channel']}>
        {renderPanelItem()}
      </div>
    </div>
  )
}

export default ChannelDemandPanel;